/* Elizalde collection kit — pendant + chain pairing (with preview) and bracelet stack builder (adds several items to the bag) */
(function () {
  'use strict';
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function once(el) { if (el.getAttribute('data-wr-ready') === 'true') return false; el.setAttribute('data-wr-ready', 'true'); return true; }
  function money(cents) {
    var whole = Math.round(cents) % 100 === 0;
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
  }
  function readJson(root, sel) {
    var el = root.querySelector(sel);
    try { return JSON.parse(el ? el.textContent : 'null'); } catch (e) { return null; }
  }
  function firstAvailable(p) {
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i];
    return p.variants[0];
  }
  function findVariant(p, id) {
    for (var i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === String(id)) return p.variants[i];
    return firstAvailable(p);
  }
  function fillSelect(select, p, current) {
    if (!select) return;
    select.innerHTML = '';
    p.variants.forEach(function (v) {
      var o = document.createElement('option');
      o.value = v.id;
      o.textContent = v.title + (v.available ? '' : ' — sold out');
      o.disabled = !v.available;
      if (String(v.id) === String(current.id)) o.selected = true;
      select.appendChild(o);
    });
    select.hidden = p.variants.length < 2;
  }
  /* items: variant ids, or { id, properties } objects */
  function addItems(items, btn, status) {
    if (!items.length) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-busy') || 'Adding…';
    if (status) { status.textContent = ''; status.classList.remove('is-error'); }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var lines = items.map(function (x) {
      if (x && typeof x === 'object') {
        var line = { id: Number(x.id), quantity: 1 };
        if (x.properties && Object.keys(x.properties).length) line.properties = x.properties;
        return line;
      }
      return { id: Number(x), quantity: 1 };
    });
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to your bag.');
        window.location.href = root + 'cart';
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        if (status) { status.textContent = err.message; status.classList.add('is-error'); }
      });
  }

  /* Fields the shopper types or picks on the product form (a name, an initial, app options) */
  function customFields(form) {
    if (!form) return [];
    return qsa('[name^="properties["]').filter(function (el) {
      if (el.form !== form || el.disabled) return false;
      if (/^properties\[_/.test(el.name)) return false;
      return !/^(hidden|checkbox|radio|submit|button)$/.test(el.type);
    });
  }
  /* Ticked options on the product form (for example gift packaging), copied onto the pendant */
  function formProps(form) {
    var out = {};
    if (!form) return out;
    qsa('[name^="properties["]').forEach(function (el) {
      if (el.form !== form || el.disabled) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      var key = el.name.slice(11, -1);
      if (!key || el.value === '' || out[key] !== undefined) return;
      out[key] = el.value;
    });
    return out;
  }

  /* Horizontal pick rails with arrow buttons */
  function rails(root) {
    qsa('[data-rail]', root).forEach(function (track) {
      var box = track.parentNode;
      var prev = box.querySelector('[data-rail-step="-1"]');
      var next = box.querySelector('[data-rail-step="1"]');
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        box.classList.toggle('is-static', max <= 0);
      }
      [prev, next].forEach(function (b) {
        if (!b) return;
        b.addEventListener('click', function () {
          track.scrollBy({ left: parseInt(b.getAttribute('data-rail-step'), 10) * track.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* Pendant size variants make the pendant a little bigger or smaller in the preview */
  function scaleFor(v) {
    var t = ((v && v.title) || '').toLowerCase();
    if (/xx-?large/.test(t)) return 1.45;
    if (/x-large|extra large/.test(t)) return 1.3;
    if (/large/.test(t)) return 1.16;
    if (/x-small|extra small/.test(t)) return 0.78;
    if (/small/.test(t)) return 0.88;
    return 1;
  }

  /* Pendant + chain.
     On a product page the section sets data-pair-form (the page's product form). The pendant then follows the
     size picked on the page and keeps ticked options such as gift packaging. When the product form asks the shopper
     for something (a name, an initial), the section switches to chain only: the pendant is added with the page's own
     Add to cart button, so nothing the shopper types is skipped. data-pair-mode="chain" starts it that way. */
  function pairing(root) {
    if (!once(root)) return;
    var data = readJson(root, '[data-pair-json]');
    if (!data) return;
    var sel = { pendants: 0, chains: 0 };
    var chosen = {};
    var add = root.querySelector('[data-pair-add]');
    var status = root.querySelector('[data-pair-status]');
    var stage = root.querySelector('[data-pair-stage]');
    var canvas = root.querySelector('[data-pair-canvas]');
    var formSel = root.getAttribute('data-pair-form');
    var mainForm = formSel ? document.querySelector(formSel) : null;
    var chainOnly = false;
    var token = 0;
    var lastPreview = '';
    var lastFormId = null;
    rails(root);
    function part(kind) {
      var list = data[kind] || [];
      var p = list[sel[kind]];
      if (!p) return null;
      if (!chosen[kind] || chosen[kind].p !== p) chosen[kind] = { p: p, v: firstAvailable(p) };
      return chosen[kind];
    }
    function setMode() {
      var only = root.getAttribute('data-pair-mode') === 'chain' || customFields(mainForm).length > 0;
      chainOnly = only;
      root.classList.toggle('is-chain-only', only);
      if (add && !add.disabled) {
        var lbl = add.getAttribute(only ? 'data-label-chain' : 'data-label-both');
        if (lbl) add.textContent = lbl;
      }
    }
    function syncFromForm() {
      if (!mainForm) return false;
      var idEl = mainForm.querySelector('[name="id"]');
      var c = part('pendants');
      if (!idEl || !c || String(idEl.value) === lastFormId) return false;
      lastFormId = String(idEl.value);
      for (var i = 0; i < c.p.variants.length; i++) {
        if (String(c.p.variants[i].id) === String(idEl.value) && c.v !== c.p.variants[i]) { c.v = c.p.variants[i]; return true; }
      }
      return false;
    }
    function preview(pend, chain) {
      if (!stage) return;
      if (!canvas || !window.WrPairPreview || !pend || !chain) { stage.classList.add('is-fallback'); return; }
      var key = (pend.p.big || pend.p.img) + '|' + (chain.v.img || chain.p.big || chain.p.img) + '|' + scaleFor(pend.v);
      if (key === lastPreview) return;
      lastPreview = key;
      var my = ++token;
      stage.setAttribute('aria-busy', 'true');
      var off = document.createElement('canvas');
      off.width = canvas.width; off.height = canvas.height;
      window.WrPairPreview.render(off, {
        pendant: pend.p.big || pend.p.img,
        chain: chain.v.img || chain.p.big || chain.p.img,
        scale: scaleFor(pend.v)
      }).then(function (ok) {
        if (my !== token) return;
        stage.removeAttribute('aria-busy');
        stage.classList.toggle('is-fallback', !ok);
        if (ok) {
          var ctx = canvas.getContext('2d');
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(off, 0, 0);
          canvas.setAttribute('aria-label', 'Preview: ' + pend.p.title + ' on the ' + chain.p.title);
        }
      });
    }
    function render() {
      var total = 0, ok = true;
      ['pendants', 'chains'].forEach(function (kind) {
        qsa('[data-pick="' + kind + '"]', root).forEach(function (b) {
          b.setAttribute('aria-pressed', parseInt(b.getAttribute('data-index'), 10) === sel[kind] ? 'true' : 'false');
        });
        var c = part(kind);
        if (!c) { ok = false; return; }
        var img = root.querySelector('[data-pair-img="' + kind + '"]');
        if (img) { img.src = c.p.img; img.alt = c.p.title; }
        var name = root.querySelector('[data-pair-name="' + kind + '"]');
        if (name) { name.textContent = c.p.title; name.setAttribute('href', c.p.url); }
        fillSelect(root.querySelector('[data-pair-select="' + kind + '"]'), c.p, c.v);
        var price = root.querySelector('[data-pair-price="' + kind + '"]');
        if (price) price.textContent = money(c.v.price);
        if (chainOnly && kind === 'pendants') return;
        total += c.v.price;
        if (!c.v.available) ok = false;
      });
      var t = root.querySelector('[data-pair-total]');
      if (t) t.textContent = money(total);
      if (add) add.disabled = !ok;
      preview(part('pendants'), part('chains'));
    }
    qsa('[data-pick]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        sel[b.getAttribute('data-pick')] = parseInt(b.getAttribute('data-index'), 10);
        render();
      });
    });
    ['pendants', 'chains'].forEach(function (kind) {
      var s = root.querySelector('[data-pair-select="' + kind + '"]');
      if (s) s.addEventListener('change', function () { var c = part(kind); c.v = findVariant(c.p, s.value); render(); });
    });
    if (add) add.addEventListener('click', function () {
      setMode();
      var chain = part('chains');
      if (chainOnly) { addItems([chain.v.id], add, status); return; }
      addItems([{ id: part('pendants').v.id, properties: formProps(mainForm) }, chain.v.id], add, status);
    });
    if (mainForm) {
      syncFromForm();
      /* the page's size picker and app options can change after load */
      document.addEventListener('change', function (e) {
        if (root.contains(e.target)) return;
        setTimeout(function () {
          var was = chainOnly;
          setMode();
          if (syncFromForm() || was !== chainOnly) render();
        }, 80);
      });
      [1500, 4000].forEach(function (ms) {
        setTimeout(function () { var was = chainOnly; setMode(); if (was !== chainOnly) render(); }, ms);
      });
    }
    setMode();
    render();
  }

  /* Bracelet stack */
  function stack(root) {
    if (!once(root)) return;
    var data = readJson(root, '[data-stack-json]');
    if (!data) return;
    var max = data.max || 4;
    var byKey = {};
    data.items.forEach(function (p) { byKey[p.key] = p; });
    var picked = [];
    var add = root.querySelector('[data-stack-add]');
    var status = root.querySelector('[data-stack-status]');
    var visual = root.querySelector('[data-stack-visual]');
    var list = root.querySelector('[data-stack-list]');
    function setFrom(keys) {
      picked = keys.filter(function (k) { return byKey[k]; }).slice(0, max).map(function (k) { return { p: byKey[k], v: firstAvailable(byKey[k]) }; });
    }
    function has(k) { return picked.some(function (x) { return x.p.key === k; }); }
    function render() {
      var keys = picked.map(function (x) { return x.p.key; }).join(',');
      qsa('[data-key]', root).forEach(function (b) {
        var on = has(b.getAttribute('data-key'));
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.disabled = !on && picked.length >= max;
      });
      qsa('[data-preset]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-preset') === keys ? 'true' : 'false'); });
      var note = root.querySelector('[data-stack-note]');
      if (note) note.textContent = picked.length + ' of ' + max;
      visual.innerHTML = '';
      list.innerHTML = '';
      var total = 0, compare = 0, ok = picked.length > 0;
      if (!picked.length) {
        var empty = document.createElement('p');
        empty.textContent = visual.getAttribute('data-empty') || 'Add bracelets to see your stack';
        visual.appendChild(empty);
      }
      picked.forEach(function (x) {
        var span = document.createElement('span');
        var im = document.createElement('img');
        im.src = x.p.img; im.alt = ''; im.loading = 'lazy';
        span.appendChild(im);
        visual.appendChild(span);
        var li = document.createElement('li');
        li.className = 'wr-line';
        var a = document.createElement('a');
        a.className = 'wr-line__name'; a.href = x.p.url; a.textContent = x.p.title;
        li.appendChild(a);
        var right = document.createElement('span');
        right.className = 'wr-line__right';
        if (x.p.variants.length > 1) {
          var s = document.createElement('select');
          s.className = 'wr-select';
          s.setAttribute('aria-label', 'Option for ' + x.p.title);
          fillSelect(s, x.p, x.v);
          s.addEventListener('change', function () { x.v = findVariant(x.p, s.value); render(); });
          right.appendChild(s);
        }
        var pr = document.createElement('span');
        pr.textContent = money(x.v.price);
        right.appendChild(pr);
        var rm = document.createElement('button');
        rm.type = 'button'; rm.className = 'wr-icon-btn'; rm.setAttribute('aria-label', 'Remove ' + x.p.title);
        rm.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg>';
        rm.addEventListener('click', function () { picked = picked.filter(function (y) { return y !== x; }); render(); });
        right.appendChild(rm);
        li.appendChild(right);
        list.appendChild(li);
        total += x.v.price;
        compare += Math.max(x.v.compare || 0, x.v.price);
        if (!x.v.available) ok = false;
      });
      var t = root.querySelector('[data-stack-total]');
      if (t) t.textContent = money(total);
      var saveRow = root.querySelector('[data-stack-save-row]');
      var save = root.querySelector('[data-stack-save]');
      if (saveRow) saveRow.hidden = compare - total <= 0;
      if (save) save.textContent = money(compare - total);
      if (add) add.disabled = !ok;
    }
    qsa('[data-key]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-key');
        if (has(k)) picked = picked.filter(function (x) { return x.p.key !== k; });
        else if (picked.length < max) picked.push({ p: byKey[k], v: firstAvailable(byKey[k]) });
        render();
      });
    });
    qsa('[data-preset]', root).forEach(function (b) {
      b.addEventListener('click', function () { setFrom(b.getAttribute('data-preset').split(',')); render(); });
    });
    if (add) add.addEventListener('click', function () { addItems(picked.map(function (x) { return x.v.id; }), add, status); });
    var first = root.querySelector('[data-preset]');
    if (first) setFrom(first.getAttribute('data-preset').split(','));
    render();
  }

  function initIn(scope) {
    qsa('[data-wr-pair]', scope).forEach(pairing);
    qsa('[data-wr-stack]', scope).forEach(stack);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initIn(document); });
  else initIn(document);
  document.addEventListener('shopify:section:load', function (e) { initIn(e.target); });
})();
